import { ViewConfiguration } from '../../../grid/gridView/types';
import { ColumnDetails } from '../../../grid/types/common';
import { Integration } from '../../common/types';
import { LicenseStatus } from '../../../license/types/LicenseStatus';

export enum Column {
  NAME,
  TYPE,
  STATUS,
  RESPONSE_STATUS,
  COMPANY_NAME,
}

export enum ColumnKeys {
  NAME = 'name',
  TYPE = 'type',
  STATUS = 'status',
  RESPONSE_STATUS = 'responseStatus',
  COMPANY_NAME = 'companyName',
}

export const FILTERS = [{ type: { in: [] } }, { status: { in: [] } }, { responseStatus: { in: [] } }];

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.TYPE, ColumnKeys.COMPANY_NAME, ColumnKeys.STATUS, ColumnKeys.RESPONSE_STATUS];

export const DEFAULT_PAGE_SIZE = 20;

export interface IntegrationsGridViewData {
  views: Array<ViewConfiguration<Column, ColumnKeys>>;
  allColumns: Array<ColumnDetails<Column, ColumnKeys>>;
  defaultViewProps: ViewConfiguration<Column, ColumnKeys>;
  data: { licenses: Array<License> };
  predefinedFilterKeys: Array<ColumnKeys>;
}

export interface IntegrationsGridGetRowsResponse {
  rawEvents?: Array<Integration>;
}

export interface License {
  _id: string;
  productId: number;
  status: LicenseStatus;
  expiryDate: string;
}
